__turbopack_context__.v({
  "className": "instrument_serif_48ecddc-module__WriUGa__className",
});
